import _extends from '@babel/runtime/helpers/extends';
import React__default, { useState, useRef, Children, isValidElement } from 'react';
import styled from 'styled-components';
import { S as SplitButtonWrapper, B as ButtonGroupFrame, a as StyledMainButton, b as StyledMenuButton } from './SplitButton.styles-BOPIYVlh.js';
import { M as Menu } from '../../Menu/Menu-CWnOwu1o.js';
import { a as TaktIdConsumer } from '../../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';
import { g as ellipsisH } from '../../LocalModules/storm-ui-icons/dist/esm/localIcons-B_pWoZ1u-Bxh9jPb6.js';

const StyledMenu = /*#__PURE__*/styled(Menu).withConfig({
  componentId: "sc-storm-ui-40020072__sc-1qrlwcw-0"
})(["", ";"], ({
  $minWidth
}) => {
  /* Only set a min-width if we get a positive number. Add 2px for the border thickness */
  const minWidth = $minWidth && $minWidth >= 0 ? $minWidth + 2 : undefined;
  return minWidth ? `
      width: auto;
      min-width: ${minWidth}px;
    ` : '';
});
const SplitButton = ({
  mainButtonLabel,
  disabled,
  children,
  mainButtonOnClick,
  dropdownLabel = 'Toggle Dropdown',
  fullWidth,
  id,
  taktId,
  taktValue,
  loading,
  ...rest
}) => {
  const [isPopoverVisible, setPopoverVisible] = useState(false);
  const splitDropdownButtonRef = useRef(null);
  const anchorRef = useRef(null);
  const togglePopoverView = () => {
    setPopoverVisible(!isPopoverVisible);
  };
  const handleMainButtonClick = event => {
    if (isPopoverVisible) {
      togglePopoverView();
    }
    mainButtonOnClick === null || mainButtonOnClick === void 0 || mainButtonOnClick(event);
  };
  const onCloseHandler = event => {
    var _splitDropdownButtonR;
    if (event && event.target instanceof Node && splitDropdownButtonRef && !((_splitDropdownButtonR = splitDropdownButtonRef.current) !== null && _splitDropdownButtonR !== void 0 && _splitDropdownButtonR.contains(event.target))) {
      togglePopoverView();
    }
  };
  return /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
    taktId: taktId,
    taktValue: taktValue,
    fallbackId: createStormTaktId('split-button')
  }, ({
    getDataTaktAttributes
  }) => {
    var _anchorRef$current;
    return /*#__PURE__*/React__default.createElement(SplitButtonWrapper, {
      ref: anchorRef
    }, /*#__PURE__*/React__default.createElement(StyledMenu, {
      id: id ? `${id}-menu` : 'menu',
      isOpen: isPopoverVisible,
      align: "center",
      onClose: onCloseHandler,
      $minWidth: (_anchorRef$current = anchorRef.current) === null || _anchorRef$current === void 0 ? void 0 : _anchorRef$current.getBoundingClientRect().width,
      trigger: /*#__PURE__*/React__default.createElement(ButtonGroupFrame, null, /*#__PURE__*/React__default.createElement(StyledMainButton, _extends({}, getDataTaktAttributes(), rest, {
        id: id,
        type: "button",
        disabled: disabled,
        $fullWidth: fullWidth,
        onClick: loading ? undefined : handleMainButtonClick,
        loading: loading
      }, loading && {
        'aria-live': 'assertive'
      }, loading && {
        'aria-disabled': true
      }), mainButtonLabel), /*#__PURE__*/React__default.createElement(StyledMenuButton, _extends({}, getDataTaktAttributes({
        taktIdSuffix: 'menu'
      }), rest, {
        buttonRef: splitDropdownButtonRef,
        icon: ellipsisH,
        label: "open/close menu",
        id: typeof id === 'string' ? `${id}-menu-button` : undefined,
        disabled: disabled || loading,
        onClick: togglePopoverView,
        "aria-haspopup": "true",
        "aria-expanded": isPopoverVisible
      })))
    }, Children.map(children, child => {
      if (/*#__PURE__*/isValidElement(child)) {
        return /*#__PURE__*/React__default.cloneElement(child, {
          ...child.props,
          onClick: () => {
            var _child$props, _child$props$onClick;
            togglePopoverView();
            (_child$props = child.props) === null || _child$props === void 0 || (_child$props$onClick = _child$props.onClick) === null || _child$props$onClick === void 0 || _child$props$onClick.call(_child$props);
          },
          key: child.props.value
        });
      }
      return child;
    })));
  });
};

export { SplitButton as S };
//# sourceMappingURL=SplitButton-tgn38buF.js.map
